<div [ngClass]="openFilter" class="searchFilter bx-filters">
  <!-- *ngIf="open" -->
  <div class="row">
    <form [formGroup]="form">
      <div *ngIf="view == 'Case'" class="col-12 selecDiv">
        <p>Tipo de caso</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="caseType">
            <mat-option
              *ngFor="let caseType of caseTypes"
              [value]="caseType._id"
              >{{ caseType.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div class="col-12 selecDiv">
        <p>Nivel de riesgo</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="levelRisk">
            <mat-option
              *ngFor="let levelRisk of riskLevels"
              [value]="levelRisk.name"
              >{{ levelRisk.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div> -->
      <!-- <div class="col-12 selecDiv">
        <p>Estado</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="state">
            <mat-option
              *ngFor="let state of view == 'Case' ? states : statesAlert"
              [value]="state.value"
              >{{ state.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div> -->
      <div class="col-12 selecDiv">
        <p>Fecha</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select (change)="setDays()" formControlName="date">
            <mat-option *ngFor="let d of dates" [value]="d.value">{{
              d.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 selecDiv">
        <p>{{ view == "Case" ? "Especialista" : "Asignado" }}</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="assigned">
            <mat-option *ngFor="let user of users" [value]="user._id">{{
              user.fullname
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div *ngIf="view == 'Alert'" class="col-12 selecDiv">
        <p>Creador</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="creator">
            <mat-option *ngFor="let user of users" [value]="user._id">{{
              user.fullname
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
    </form>
    <div class="bx-filters__actions">
      <button mat-flat-button color="primary" type="button" (click)="search()">Aplicar</button>
      <button mat-button type="button" (click)="cleanFilter()">Limpiar</button>
    </div>
  </div>
</div>
